export default __webpack_public_path__ + "static/media/bet7.7f255803.png";